//@ts-ignore
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Icon } from '@iconify/react';
import "./styles.css"
import { FC } from "react";
import { IDatePickerType } from "./DatePicker.type";

const DatePickerC :FC<IDatePickerType> = ({ disabled, Apply, dates, className = {}, isSingle, placeholderText, placeholder = "" }) => {
  return (
    <div className={`  datepicker-container ${className || 'col-md-6'}`}>
      <label className="label">
        {placeholder}
      </label>
      <div className={`DatePicker`} >
        <DatePicker
          showIcon
          icon={<Icon icon="ci:calendar-days" className='DateIcon' />}
          className="dateInput"
          selectsRange={!isSingle}
          placeholderText={placeholder || placeholderText}
          startDate={!isSingle && dates?.from}
          endDate={!isSingle && dates?.to}
          selected={isSingle && dates}
          showYearDropdown
          yearDropdownItemNumber={50}
          isClearable={true}
          scrollableYearDropdown
          disabled={disabled}
          onChange={(d:any) => {
            Apply((isSingle) ? d : { from: d[0], to: d[1] })
          }}
          dateFormat="dd-MM-yyyy"
        />
      </div>
    </div>)
}

export default DatePickerC